var _path, _circle, _rect, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05Exercise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6012 32.1864C21.7162 31.985 21.8983 31.831 22.1132 31.7438C27.9701 29.367 32.1003 23.6219 32.1003 16.912C32.1003 8.07546 24.9369 0.912018 16.1003 0.912018C7.26379 0.912018 0.100342 8.07546 0.100342 16.912C0.100342 23.708 4.3374 29.5144 10.314 31.8337C10.5352 31.9195 10.7232 32.0759 10.8409 32.282L14.4572 38.6106C15.225 39.9542 17.1624 39.9542 17.9302 38.6106L21.6012 32.1864Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1003,
    cy: 16.912,
    r: 13.5,
    fill: "#291F50"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.33618,
    y: 9.69199,
    width: 8.56663,
    height: 3.80739,
    rx: 0.6,
    fill: "#E7E6F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4778,
    y: 9.69199,
    width: 4.28331,
    height: 15.2296,
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4778 13.5013H15.7611V17.3343L11.4778 14.4773V13.5013Z",
    fill: "#ABA9C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.33618,
    y: 21.1142,
    width: 8.56663,
    height: 3.80739,
    rx: 0.6,
    fill: "#E7E6F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4907,
    y: 14.5461,
    width: 6.23506,
    height: 2.77114,
    rx: 0.4,
    transform: "rotate(-18 15.4907 14.5461)",
    fill: "#4841A6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9731,
    y: 14.0649,
    width: 3.11753,
    height: 11.0845,
    transform: "rotate(-18 16.9731 14.0649)",
    fill: "#4841A6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0598,
    y: 22.4522,
    width: 6.23506,
    height: 2.77114,
    rx: 0.4,
    transform: "rotate(-18 18.0598 22.4522)",
    fill: "#4841A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8267 16.6914L20.7916 15.728L21.6569 18.3913L18.0494 17.377L17.8267 16.6914Z",
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Exercise);
export default __webpack_public_path__ + "static/media/05_exercise.3dbdfc73760890a608ed0ef6a1c7757b.svg";
export { ForwardRef as ReactComponent };